/* eslint-disable no-redeclare */
import { Placement } from '@hc-frontend/core-types';
import { z } from 'zod';

export const TrackConversionRequestDto = z.object({
  type: z.literal('click'),
  monetization_platform: z.literal('site'),
  transaction_id: z.string(),
  value: z.string(),
  placement: Placement,
  healthcare_session: z.string(),
});

export type TrackConversionRequestDto = z.infer<
  typeof TrackConversionRequestDto
>;

export const TrackConversionResponseDto = z.object({
  data: z.string(),
});

export type TrackConversionResponseDto = z.infer<
  typeof TrackConversionResponseDto
>;
